import { getClientEnvironmentDetails } from '@sm/utils';
import { BiEventsDataProps, BiEventReturnType, DeviceTypes } from '~app/pages/SurveyTaking/types';

const DeviceType = {
  MOBILE: 'MOBILE',
  DESKTOP: 'PC',
  TABLET: 'TABLET',
  OTHER: 'OTHER',
  BOT: 'BOT',
} as const;

const _getDeviceType = (): DeviceTypes => {
  const { isMobile, isDesktop, isTablet } = getClientEnvironmentDetails();

  if (isMobile) return DeviceType.MOBILE;
  if (isDesktop) return DeviceType.DESKTOP;
  if (isTablet) return DeviceType.TABLET;
  // if (isBot) return DeviceType.BOT;

  return DeviceType.OTHER;
};

export const generateEventData = ({
  environment,
  user,
  collector,
  survey,
  currentPage,
}: BiEventsDataProps): BiEventReturnType => {
  const { countryCode, domain, tld } = environment;
  const { package: packageId, id: userId } = user;

  return {
    collector_id: collector?.id,
    collector_type: collector?.type,
    country: countryCode,
    device_type: _getDeviceType(),
    domain_setting: `${domain}.${tld}`,
    footer_status: survey?.design?.footer?.enabled,
    is_custom_theme: survey?.design?.theme?.isCustomTheme,
    is_group_theme: survey?.design?.theme?.isTeamTheme,
    is_stock_theme: survey?.design?.theme?.isStockTheme,
    is_survey_quiz_enabled: survey?.isQuiz,
    language: survey?.language.name,
    logo_status: survey?.design?.logo?.enabled,
    package_id: packageId,
    page_count: survey?.pages?.totalCount,
    page_number: currentPage?.position,
    question_count: currentPage?.questionsQM?.totalCount,
    response_quality: '',
    survey_id: survey?.id ?? '',
    survey_language_id: survey?.language.id ?? '',
    survey_owner_user_id: survey?.userId ?? '', // TODO: Still needed?
    survey_style: survey?.format ?? null,
    theme_id: survey?.design?.theme?.id ?? '',
    theme_name: survey?.design?.theme?.name ?? '',
    theme_version: survey?.design?.theme?.version ?? 'V3',
    user_id: userId,
    version: survey?.version ?? 1,
  };
};

export default generateEventData;
